import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigate, useParams } from 'react-router-dom';
import GenericPage from './GenericPage';
import TermsPage from './TermsPage';
import TermsAccept from './TermsAccept';
import ErrorPage from './ErrorPage';
import SuccessPage from './SuccessPage';
import HomePlusTermsPage from './HomePlusTermsPage';
import HomePlusTermsAccept from './HomePlusTermsAccept';
import HomePlusTermsWithValPage from './HomePlusTermsWithValPage';
import HomePlusTermsWithValAccept from './HomePlusTermsWithValAccept';
import HomePlusSuccessPage from './HomePlusSuccessPage';
import VL2TermsPage from './VL2TermsPage';
import VL2TermsAccept from './VL2TermsAccept';
import VL2SuccessPage from './VL2SuccessPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';

function ValidateTermId({ children }) {
  const { termId } = useParams();
  const isValidTermId = /^ES-\d{7,8}$/.test(termId);

  if (!isValidTermId) {
    return <Navigate to="/error" replace />;
  }

  if (typeof children === 'function') {
    return children(termId);
  } else {

    return React.cloneElement(children, { termId });
  }
}

function NavigationPane({ isDocumentOpen, toggleDocument }) {
  const location = useLocation();
  const baseURL = window.location.origin;

  // Check if current path includes homeplus-terms or homeplus-with-valuation-terms
  const isHomePlusRoute = location.pathname.includes('/homeplus-terms') || location.pathname.includes('/homeplus-with-valuation-terms');

  // Check if valunation route
  const isValunationRoute = location.pathname.includes('/vl2-terms') || location.pathname.includes('/vl2-terms-accept') || location.pathname.includes('/vl2-thank-you');

  // Base PDF files that are always available
  const basePdfFiles = [
    {
      name: 'Helping you choose the right survey - Information sheet',
      url: baseURL + '/pdfs/Home_surveys_information_sheet_HomeBuyer_Survey 5th Edition.pdf'
    },
    {
      name: 'Leasehold properties advice',
      url: baseURL + '/pdfs/Leasehold_properties_advice_HomeBuyer_Survey 5th Edition.pdf'
    }
  ];

  // Conditionally add HomePlus Guide for homeplus-terms routes
  let pdfFiles = isHomePlusRoute
    ? [
        ...basePdfFiles,
        {
          name: 'HomePlus Guide',
          url: baseURL + '/pdfs/HomePlus Guide.pdf'
        }
      ]
    : basePdfFiles;

  // Add T&Cs for VL2 route
  if (isValunationRoute) {
    pdfFiles = [
      ...pdfFiles,
      {
        name: 'Letter of Engagement',
        url: baseURL + '/pdfs/Valunation_Engagement_Letter.pdf'
      },
      {
        name: 'Terms and Conditions',
        url: baseURL + '/pdfs/Valunation_Terms.pdf'
      }
    ];
  }

  return (
    <nav>
      <div onClick={toggleDocument} className="document-title dropdown-toggle">
        Your Documents
      </div>

      {isDocumentOpen && (
        <ul className="document-list">
          {pdfFiles.map((pdf, index) => (
            <li key={index}>
              <a href={pdf.url} target="_blank" rel="noopener noreferrer">
                {pdf.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}

function App() {
  const [isPaneOpen, setPaneOpen] = useState(window.innerWidth >= 768);
  const [lastWidth, setLastWidth] = useState(window.innerWidth);
  const [isDocumentOpen, setDocumentOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState();

  useEffect(() => {
    fetch('/api/date')
      .then(res => res.json())
      .then(data => {
        setCurrentTime(data.date);
      })
      .catch(error => {
        console.log('API date fetch failed:', error);
        setCurrentTime(new Date().toLocaleDateString('en-GB'));
      });
  }, []);

  useEffect(() => {
    // sets the pane open/closed based on screen width
    const checkPaneState = () => {
      const currentWidth = window.innerWidth;

      if (currentWidth < 768 && lastWidth >= 768 && isPaneOpen) {
        setPaneOpen(false);
      } else if (currentWidth >= 768 && lastWidth < 768 && !isPaneOpen) {
        setPaneOpen(true);
      }

      setLastWidth(currentWidth);
    };

    checkPaneState();
    window.addEventListener('resize', checkPaneState);

    return () => {
      window.removeEventListener('resize', checkPaneState);
    };
  }, [isPaneOpen, lastWidth]);


  const togglePane = () => {
    setPaneOpen(!isPaneOpen);
  };

  // const baseURL = window.location.origin;
  // const pdfFiles = [
  //   {
  //     name: 'Helping you choose the right survey - Information sheet',
  //     url: baseURL + '/pdfs/Home_surveys_information_sheet_HomeBuyer_Survey 5th Edition.pdf'
  //   },
  //   {
  //     name: 'Leasehold properties advice',
  //     url: baseURL + '/pdfs/Leasehold_properties_advice_HomeBuyer_Survey 5th Edition.pdf'
  //   },
  //   {
  //     name: 'New Document',
  //     url: baseURL + 'pdfs/HomePlus Guide.pdf'
  //   }
  // ];

  const toggleDocument = () => {
    setDocumentOpen(!isDocumentOpen);
  };


  return (
    <Router>
      <div className={`App ${isPaneOpen ? 'open' : 'closed'}`}>
        <div className="left-pane">
          <button onClick={togglePane} className="toggle-button">
            <FontAwesomeIcon icon={isPaneOpen ? faBars : faBars} className="hamburger-icon" />
          </button>
          <div className="logo">
            <img className="logo" alt="" src="https://cdn.esurv.co.uk/wp-content/uploads/2017/05/logo-esurv-white-208x80.png"></img>
          </div>
          <div>
            <p className='date'>{currentTime}</p>
            </div>
            <NavigationPane
            isDocumentOpen={isDocumentOpen}
            toggleDocument={toggleDocument}
          />


          <p style={{
            color: 'white', padding: '20px', fontSize: '14px'
          }}>If you're unsure about anything or wish to cancel, please call us quoting your reference number.</p>
          <h4 style={{
            color: 'white'
          }}>01536 534594</h4>
        </div>



        <main className="main-content">
          <p className='date'>{currentTime}</p>

          <Routes>
            <Route path="/" element={<GenericPage />} />
            <Route path="/terms/:termId" element={
              <ValidateTermId>
                <TermsPage />
              </ValidateTermId>
            } />
            <Route path="/terms-accept/:termId" element={
              <ValidateTermId>
                <TermsAccept />
              </ValidateTermId>
            } />
            <Route path="/thank-you/:termId" element={
              <ValidateTermId>
                <SuccessPage />
              </ValidateTermId>
            } />
            <Route path="/homeplus-terms/:termId" element={
              <ValidateTermId>
                <HomePlusTermsPage />
              </ValidateTermId>
            } />
            <Route path="/homeplus-terms-accept/:termId" element={
              <ValidateTermId>
                <HomePlusTermsAccept />
              </ValidateTermId>
            } />
            <Route path="/homeplus-with-valuation-terms/:termId" element={
              <ValidateTermId>
                <HomePlusTermsWithValPage />
              </ValidateTermId>
            } />
            <Route path="/homeplus-with-valuation-terms-accept/:termId" element={
              <ValidateTermId>
                <HomePlusTermsWithValAccept />
              </ValidateTermId>
            } />
            <Route path="/homeplus-thank-you/:termId" element={
              <ValidateTermId>
                <HomePlusSuccessPage />
              </ValidateTermId>
            } />
            <Route path="/vl2-terms/:termId" element={
              <ValidateTermId>
                <VL2TermsPage />
              </ValidateTermId>
            } />
            <Route path="/vl2-terms-accept/:termId" element={
              <ValidateTermId>
                <VL2TermsAccept />
              </ValidateTermId>
            } />
            <Route path="/vl2-thank-you/:termId" element={
              <ValidateTermId>
                <VL2SuccessPage />
              </ValidateTermId>
            } />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
